import axiosInstance from './axiosInstance'

export const getDisplayPricingById = (pricingId) => {
  return axiosInstance.get(`/display-pricings/${pricingId}`)
}

export const getDisplayPricingByIds = (ids = []) => {
  return axiosInstance.get(`/display-pricings/ids?ids=${ids.join(',')}`)
}

export const getDisplayPricings = (page = 1, limit = 50, search = '', orderByKey = 'keyNo', direction = 'asc', height = null, length = null) => {
  return axiosInstance.get(`/display-pricings?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}${height ? '&height=' + height : ''}${length ? '&length=' + length : ''}`)
}

export const createDisplayPricing = (data) => {
  return axiosInstance.post('/display-pricings', data)
}

export const updateDisplayPricing = (pricingId, data) => {
  return axiosInstance.put(`/display-pricings/${pricingId}`, data)
}

export const deleteDisplayPricing = (pricingId) => {
  return axiosInstance.delete(`/display-pricings/${pricingId}`)
}

export const exportDisplayPricings = () => {
  return axiosInstance.post('/display-pricings/export')
}

export const importDisplayPricings = (data) => {
  return axiosInstance.post('/display-pricings/import', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
